import { Types } from '../Constants/Types';
import OrderActivityType from '../Interfaces/order-activities.interface';

const initialState: OrderActivityType['status'] = {
  orderActivities: [],
  lorderActivities: false,
  error: null,
};

const OrderActivityReducer = (
  state: OrderActivityType['status'] = initialState,
  action: OrderActivityType['action']
) => {
  switch (action.type) {
    case Types.FETCH_ORDER_ACTIVITIES:
      return { ...state, orderActivities: action.payload || [], error: null };

    case Types.START_ORDER_ACTIVITIES:
      return { ...state, lorderActivities: true };

    case Types.END_ORDER_ACTIVITIES:
      return { ...state, lorderActivities: false };

    // A failed read leaves no rows behind rather than half a feed.
    case Types.ERROR_ORDER_ACTIVITIES:
      return { ...state, orderActivities: [], error: action.payload };

    case Types.RESET_ORDER_ACTIVITIES:
      return { ...initialState };

    default:
      return state;
  }
};

export default OrderActivityReducer;
